import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import user from './user'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    isLoadingForSumbit: false,
  },
  mutations: {
    SET_IS_LOADING_FOR_SUBMIT(state, payload) {
      state.isLoadingForSumbit = payload
    },
  },
  modules: {
    app,
    appConfig,
    verticalMenu,
    user,
  },
  strict: process.env.DEV,
})
